// Which boxes the server complained about: they turn red until the person types in them or the next save works.
import { useSyncExternalStore } from "react";

let current = new Set();
const subs = new Set();
const emit = () => subs.forEach((f) => f());

export function setFieldErrors(fields) {
  current = new Set(fields || []);
  emit();
}
export function clearFieldError(key) {
  const keys = [].concat(key || []);
  if (keys.some((k) => current.has(k))) {
    current = new Set([...current].filter((k) => !keys.includes(k)));
    emit();
  }
}
export function useFieldError(key) {
  const keys = [].concat(key || []);
  return useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => keys.some((k) => current.has(k)));
}

// a box's label -> the name the server uses for it (so every form lights up without naming each box)
const KEYS = [
  [/^truck\b/i, "truck_id"], [/^to which truck/i, "truck_id"], [/^driver/i, "driver_id"], [/^trailer/i, "trailer_id"], [/^which mechanic/i, "mechanic_id"], [/^which outside mechanic/i, "outside_payee_id"],
  [/^(paid to|sent to)/i, "payee_id"], [/^supplier/i, "supplier_id"], [/^contract/i, "contract_id"], [/^route|^lane/i, "lane_id"],
  [/^amount/i, "amount"], [/^quantity|^qty/i, "qty"], [/^category|^what is it$/i, "category"], [/^date|^pay date|^opened|^needed by/i, "date"],
  [/^where( is the truck)?$|^place/i, "location"], [/^what happened|^details|^description/i, ["description"]], [/^what is wrong|^what is to be done/i, ["complaint", "description"]], [/^insurer$|^insurer/i, "insurer"], [/^claim number/i, "claim_no"],
  [/^code$/i, "code"], [/^name$|^full name/i, "name"], [/^collected by/i, "collected_by"], [/^serial/i, "serial"], [/^position/i, "position"],
  [/^(truck )?odometer/i, "odometer"], [/^phone|^m-pesa phone/i, "phone"], [/^id number|^id no/i, "id_no"], [/^reference|^insurer's reference/i, "reference"],
  [/^what was done/i, "work_done"], [/^what it says/i, "summary"], [/^with whom/i, "party"], [/^invoice/i, "invoice_no"], [/^reason|^why/i, "reason"],
];
export function keyForLabel(label) {
  if (typeof label !== "string") return null;
  const hit = KEYS.find(([re]) => re.test(label.trim()));
  return hit ? hit[1] : null;
}
